"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanFunctionStore = void 0;
class PlanFunctionStore {
    data = {};
    constructor() {
    }
    add(item) {
        this.data[item.getId()] = item;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(pf => {
            if (options?.branchId && pf.getBranchId() !== options.branchId) {
                return false;
            }
            if (options?.variableName && pf.getVariableName() !== options.variableName) {
                return false;
            }
            return true;
        });
    }
    delete(id) {
        delete this.data[id];
    }
}
exports.PlanFunctionStore = PlanFunctionStore;
